export function delay<T>(promise: () => Promise<T> | T, milliseconds: number = 2000): Promise<T> {
  return new Promise((res) => {
    setTimeout(res, milliseconds);
  }).then(promise);
}

export interface IAbortablePromise<T> {
  abort: () => void;
  ready: Promise<T>;
}

export function abortableFetch(request: RequestInfo, options: RequestInit): IAbortablePromise<Response> {
  const abortController = new AbortController();
  const signal = abortController.signal;
  return {
    abort: () => abortController.abort(),
    ready: fetch(request, {...options, signal: signal})
  }
}

export function abortableDelay<T>(promise: () => Promise<T> | T, milliseconds: number = 2000): IAbortablePromise<T> {
  const abortController = new AbortController();
  const signal = abortController.signal;
  return {
    abort: () => {
      abortController.abort()
    },
    ready: new Promise<void>((res, rej) => {
      let timeout: NodeJS.Timeout | undefined;
      const abortHandler = () => {
        clearTimeout(timeout);
        rej(new DOMException("Aborted", "AbortError"));
      };

      timeout = setTimeout(() => {
        if (abortController.signal.aborted) return;
        res();
        signal.removeEventListener("abort", abortHandler);
      }, milliseconds);
      signal.addEventListener("abort", abortHandler);
    }).then(promise),
  };
}
